import { FieldErrors } from 'react-hook-form';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Stack, Typography } from '@mui/material';

import type { FormValues } from '../PredefinedPromptsByRole';

interface AccordionTitleProps {
    role: string;
    roleIndex: number;
    errors: FieldErrors<FormValues>;
}

export const AccordionTitle = ({ role, roleIndex, errors }: AccordionTitleProps) => {
    const hasValidationErrors = Boolean(errors.roles?.[roleIndex]?.prompts?.length);

    return (
        <Stack direction='row' alignItems='center' gap={1}>
            <Typography variant='body2'>{role}</Typography>
            {hasValidationErrors && <ErrorOutlineIcon color='error' />}
        </Stack>
    );
};
